import React from 'react';
import queryString from 'util/qs';
import { Path } from 'react-router-dom';

export function useQueryAndHash(
  pathname: string,
  query?: string | null,
  hash?: string | null,
): Partial<Path> {
  return React.useMemo(
    () => ({
      pathname,
      search: query ? `?${queryString.stringify({ query })}` : undefined,
      hash: hash ? `#${hash}` : undefined,
    }),
    [pathname, query, hash],
  );
}
